import { FormikHelpers, useFormik } from "formik";
import { UtilService } from "../../../services/shared/UtilService";
import { msgTypes } from "../../../constants/msgTypes";
import { LocalStorageService } from "../../../services/auth/LocalStorageService";
import { Link, useNavigate } from "react-router-dom";
import { LoginSchema } from "../../../validations/Schema";
import Input from "../../../components/basicComponent/Input";
import { useEffect, useState } from "react";
import { MuiInput } from "../../../components/basicComponent/MuiInput";
import MuiButton from "../../../components/basicComponent/MuiButton";
import { AuthModel } from "../../../model/utilModels/AuthModel";
import { CoorporateType, Role } from "../../../constants/enum";
import { useGlobalState } from "../../../services/context/AuthContext";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import "./Login.scss";
const LogIn = () => {
  const navigate = useNavigate();
  const { setPermission, setUserInfo, permission } = useGlobalState();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    localStorage.removeItem(msgTypes.ACCESS_TOKEN);
    localStorage.removeItem("permissions");
  }, []);

  const formik = useFormik({
    initialValues: new AuthModel(),
    validationSchema: LoginSchema,
    onSubmit(values, formikHelpers) {
      setIsLoading(true);
      onSubmit(values);
    },
  });

  const onSubmit = async (values: AuthModel) => {
    const payload = { ...values };
    try {
      const response = await UtilService.login(payload);
      console.log("login response", response);
      if (response.statusMsg === msgTypes.SUCCESS.msg) {
        LocalStorageService.setToken(response?.data?.tokens.access);
        setPermission(response?.data?.menu);
        localStorage.setItem("corporate_id", response?.data?.user?.id || "");
        const data = response?.data?.user;
        const role = response?.data?.user?.roleName;
        const token = response?.data?.tokens.access;

        if (role !== Role.SUPER_ADMIN) {
          setUserInfo({
            corporate_id:
              data.roleName === "Corporate Admin"
                ? response?.data?.corporateId
                : response?.data?.createdById ?? 0,
            user_type: response?.data?.balance?.user_type,
            role: data?.role,
            email: data.email,
            firstName: data.firstName,
            id: data.id,
            lastName: data.lastName,
            roleName: data.roleName,
            token: token,
            category: {
              flightCategory:
                response.data.commission.airline_commission_category,
              hotelCategory: response.data.commission.hotel_commission_category,
            },
            currencyCode: response?.data?.balance?.currency,
          });
        } else {
          setUserInfo({
            currencyCode: response?.data?.balance?.currency ?? "AED",
            user_type: data?.user_type,
            role: data?.role,
            email: data.email,
            firstName: data.firstName,
            id: data.id,
            lastName: data.lastName,
            roleName: data.roleName,
            token: token,
            category: {
              flightCategory:
                response.data.commission.airline_commission_category,
              hotelCategory: response.data.commission.hotel_commission_category,
            },
          });
        }
        if (response?.data?.passwordCreatedBy !== "auto") {
          navigate("/dashboard");
        } else {
          navigate("/createpassword");
        }
      } else {
        console.error("Login failed:", response);
        setIsLoading(false);
      }
    } catch (error) {
      console.error("An error occurred during login:", error);
      setIsLoading(false);
    }
  };
  return (
    <main
      style={{ backgroundColor: "#fff" }}
      className="grow h-full d-flex content px-4 login-page "
      id="content"
      role="content"
    >
      <div className=" triangle-top-right">
        <img src="media/images/Group.png" alt="login-img" />
      </div>
      <div className="login-container">
        <div className="decorative-triangle triangle-top-left"></div>
        <div className="login-form-section">
          <div className="logo-section m-auto">
            <img src="media/images/ewts-logo-(1).png" alt="logo" />
          </div>
          <div className="form-container m-auto">
            <h2 className="form-title ">Welcome To EWTS</h2>
            <form>
              <div className="input-group login-error-msg ">
                <MuiInput
                  type="email"
                  value={formik.values.email}
                  onChange={(e) => formik.setFieldValue("email", e)}
                  onBlur={formik.handleBlur}
                  isInvalid={!!(formik.touched.email && formik.errors.email)}
                  errorText={formik.errors.email}
                  placeholder="Enter your email"
                  iconStart={<MailOutlineIcon />}
                />
              </div>
              <div className="input-group login-error-msg">
                <MuiInput
                  type={showPassword ? "text" : "password"}
                  value={formik.values.password}
                  onChange={(value: any) =>
                    formik.setFieldValue("password", value)
                  }
                  onBlur={formik.handleBlur}
                  placeholder="Enter your password"
                  className={` ${
                    formik.touched.password && formik.errors.password
                      ? "border-red-500"
                      : "border-gray-300"
                  }`}
                  isInvalid={
                    !!(formik.touched.password && formik.errors.password)
                  }
                  errorText={formik.errors.password}
                  iconStart={<LockOpenIcon />}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute  me-2  right-0  mt-4 transform -translate-y-1/2 border-none bg-transparent"
                >
                  {showPassword ? (
                    <VisibilityOff
                      fontSize="small"
                      titleAccess="Hide password"
                    />
                  ) : (
                    <Visibility fontSize="small" titleAccess="Show password" />
                  )}
                </button>
              </div>
              <div className="d-flex justify-content-center">
                <MuiButton
                  label="Submit"
                  onClick={() => formik.handleSubmit()}
                  className="login-button"
                />
              </div>

              <div className="forget-password text-center pt-4">
                <Link to="/forgotpassword">
                  <span className="signupp">Forgot Password?</span>
                </Link>
              </div>
            </form>
          </div>
        </div>

        <div className="image-section">
          {/* <div className="image-overlay"></div> */}
          <img src="./media/images/login-side-img.png" alt="login-img" />
        </div>
      </div>
    </main>
  );
};

export default LogIn;
